function removeDuplicateUsersFromFA(users) {
  let seen = new Set()
  let noDupes = users.filter(el => {
    let duplicate = seen.has(el.id)
    seen.add(el.id)
    return !duplicate
  })

  return noDupes
}

function removeUserFromArray(user, users) {
  let filteredUsers = users
  if (user) {
    filteredUsers = users.filter(u => {
      return user.id !== u.id
    })
  }
  return filteredUsers
}

function arrayContainsUser(array, user) {
  if (user != null) {
    if ((array || []).some(u => u.id === user.id)) {
      return true
    }
  }
  return false
}

function alreadyRequiredUsers(requiredUsers, additionalUsers) {
  let results = []

  results = (additionalUsers || []).filter(function(additionalUser) {
    return (requiredUsers || []).some(ru => {
      return additionalUser.id === ru.id
    })
  })
  return results
}

function removeUsersFromRoleGroup(users, roleGroup) {
  let results

  results = [].concat(roleGroup.filter(rgu => users.every(u => rgu.id !== u.id)))
  return results
}

export { removeDuplicateUsersFromFA, removeUserFromArray, alreadyRequiredUsers, removeUsersFromRoleGroup, arrayContainsUser }
